import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import InputSelectSF from '../../../widgets/form/InputSelectSF'

const ApplFeeStatusModalUI = ({ context, successMsg, errorList, setErrorList,
  updateMode, submitted, onSubmit, onCancelClick,
  applFeeStatus, onApplFeeStatusChange, applFeeStatusError, setApplFeeStatusError, applFeeStatusList
}) =>
  <ModalFormUI
    context={context}
    titleLabel='Application fee payment status'
    buttonLabel='Update'
    cancelLabel='Cancel'
    isOpen={updateMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >
    <InputSelectSF type='select' name='applFeeStatus' label='Status'
      value={applFeeStatus} onChange={onApplFeeStatusChange} optionList={applFeeStatusList}
      error={applFeeStatusError} setError={setApplFeeStatusError}
    />
  </ModalFormUI>

export default ApplFeeStatusModalUI
